export class Material {
  public constructor(
    public materialNumber: string,
    public materialType: string,
    public materialDescription: string,
    public materialGroup: string,
    public crossPlantStatus: string,
    public developmentOwnership: string
  ) {}
}
